import { api } from './api.ts';

export interface TrackingLedgerInput {
  name: string;
  start_month: string;
  end_month?: string;
  currency: string;
}

export interface MonthlyRecordInput {
  ledger_id: number;
  reference_month: string;
  opening_balance: number;
  contributions: number;
  withdrawals: number;
  closing_balance: number;
  data_source_note?: string;
}

export const investmentTrackingApi = {
  createLedger: (payload: TrackingLedgerInput) => api.post('/api/v1/investment-tracking/ledgers', payload),
  listLedgers: () => api.get('/api/v1/investment-tracking/ledgers'),
  createRecord: (payload: MonthlyRecordInput) => api.post('/api/v1/investment-tracking/records', payload),
  listRecords: (ledgerId: number) => api.get(`/api/v1/investment-tracking/records?ledger_id=${ledgerId}`),
  getIndicators: (ledgerId: number, inflation?: number) => {
    const query = inflation !== undefined ? `&inflation=${inflation}` : '';
    return api.get(`/api/v1/investment-tracking/indicators?ledger_id=${ledgerId}${query}`);
  },
};
